import {
  workspaceScopingQueryUtils,
  WorkspaceScoping
} from 'v5/api/_common/query/workspace-scoping';
import { ResolvedAppScope } from '../appScope.types';

export function workspaceScopingFromResolvedScope(
  scope: ResolvedAppScope
): WorkspaceScoping {
  return workspaceScopingQueryUtils.fromScope(scope);
}
